







import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
	name: "el-input",
})
export default class ElInput extends Vue {
	@Prop({ default: () => `_id${Math.random() * 10000}` })
	id: string;

	@Prop()
	label: string;

	@Prop()
	placeholder: string;

	@Prop()
	options: any[];

	@Prop()
	value: string;

	@Prop()
	validator: Function;

	selectedOption: any = null;

	@Watch("selectedOption")
	updateValue(option) {
		if (!option) {
			this.$emit("input", undefined);
			return;
		}
		this.$emit("input", option.code);
	}
}
